import { Check, Handshake, Target } from "lucide-react";
import { GlobalAnimatedLayout } from "~/components/animation/GlobalAnimatedLayout";
import GlobalTextTitleH3 from "~/components/global/GlobalTextTitleH3";
import Separator from "~/components/global/Separator";
import { TentangKamiCompoQuickProof } from "~/routes/tentang-kami/components/TentangKamiCompoQuickProof";

const solutionPoints = [
  {
    id: 1,
    label: "Tim arsitek & tukang berpengalaman",
    image:
      "https://ik.imagekit.io/didigi/bangun-rumah-di-bekasi/jasa-bangun-rumah-di-bekasi_icon-lan-1.webp",
  },
  {
    id: 2,
    label: "RAB & gambar kerja transparan.",
    image:
      "https://ik.imagekit.io/didigi/bangun-rumah-di-bekasi/jasa-bangun-rumah-di-bekasi_icon-lan-2.webp",
  },
  {
    id: 3,
    label: "Update progres mingguan.",
    image:
      "https://ik.imagekit.io/didigi/bangun-rumah-di-bekasi/jasa-bangun-rumah-di-bekasi_icon-lan-3.webp",
  },
  {
    id: 4,
    label: "Garansi pasca pembangunan 6 bulan!",
    image:
      "https://ik.imagekit.io/didigi/bangun-rumah-di-bekasi/jasa-bangun-rumah-di-bekasi_icon-lan-4.webp",
  },
  {
    id: 5,
    label: "Pembayaran fleksibel & aman.",
    image:
      "https://ik.imagekit.io/didigi/bangun-rumah-di-bekasi/jasa-bangun-rumah-di-bekasi_icon-lan-5.webp",
  },
];

export default function JasaBangunRumahDiBekasiSect4KamiHadir() {
  return (
    <section>
      <section className="pt-[5rem]">
        <div className="flex flex-col lg:flex-row gap-5 lg:gap-20">
          {/* ============================
            LEFT — STICKY TITLE
        ============================ */}
          <div className="lg:w-[35%] w-full">
            <div className="lg:sticky lg:top-32 lg:pt-10">
              <GlobalAnimatedLayout direction="bottom" threshold={0.2}>
                <GlobalTextTitleH3 center title="Siapa Kami?" />
              </GlobalAnimatedLayout>
            </div>
          </div>

          {/* ============================
            RIGHT — MAIN CONTENT
        ============================ */}
          <div className="lg:w-[65%] w-full flex flex-col gap-6 ">
            <GlobalAnimatedLayout direction="bottom" threshold={0.2}>
              <img
                src="https://ik.imagekit.io/didigi/bangun-rumah-di-bekasi/jasa-bangun-rumah-arsinesia-logo-black-kecil.webp"
                className="mt-5 w-70"
              />
            </GlobalAnimatedLayout>
            <h2 className="pt-[2rem] text-2xl mb-2 font-semibold text-center lg:text-start">
              JASA KONTRAKTOR DAN PEMBANGUNAN LAINNYA
            </h2>
            <div className="text-center lg:text-start flex flex-col gap-3">
              <p className="text-lg ">
                Arsinesia adalah perusahaan kontraktor yang fokus pada jasa
                bangun rumah dan renovasi rumah dengan jangkauan layanan di
                Jakarta, Bogor, Depok, Tangerang, Bekasi, dan sekitarnya.
              </p>

              <p className="text-lg">
                Berpengalaman lebih dari 14 tahun, Arsinesia telah dipercaya
                menyelesaikan proyek, mulai dari pembangunan rumah tinggal,
                cluster, desain interior, hingga renovasi hunian.
              </p>

              <p className="text-lg">
                Selain rumah tinggal, Arsinesia juga melayani proyek konstruksi
                lain seperti pembangunan masjid, villa, yayasan, restoran, dan
                bangunan komersial.
              </p>
            </div>

            <GlobalAnimatedLayout direction="left" threshold={0.2}>
              <TentangKamiCompoQuickProof />
            </GlobalAnimatedLayout>
          </div>
        </div>
        <Separator />
        {/* MENGAPA KAMI */}
        <div className="flex flex-col lg:flex-row gap-5 lg:gap-20">
          {/* ============================
            LEFT — STICKY TITLE
        ============================ */}
          <div className="lg:w-[35%] w-full">
            <div className="lg:sticky lg:top-32 lg:pt-10">
              <GlobalAnimatedLayout direction="bottom" threshold={0.2}>
                <GlobalTextTitleH3 center title="Mengapa Kami?" />
              </GlobalAnimatedLayout>
            </div>
          </div>

          {/* ============================
            RIGHT — MAIN CONTENT
        ============================ */}
          <div className="lg:w-[65%] w-full flex flex-col gap-6">
            <div className="grid grid-cols-1 gap-5 w-full ">
              {solutionPoints.map((point) => (
                <div
                  key={point.id}
                  className="px-8 py-5 bg-white flex flex-row items-center gap-3 rounded-lg shadow"
                >
                  <Check className="w-[1.5rem] h-[1.5rem] text-white bg-green-400 rounded-md shadow-xl p-1" />
                  <img
                    src={point.image}
                    alt={point.label}
                    className="w-14 h-14 object-cover rounded-md"
                  />
                  <p className="text-sm font-semibold">{point.label}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </section>
  );
}
